import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=42cb5830&scoped=true"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=42cb5830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb5830",
  null
  
)

export default component.exports